'use client';

/**
 * The "Monday report" sample (Wave B) — DETERMINISTIC, zero LLM.
 *
 * Section titles derive from the draft's own questions (deriveSectionTitle);
 * the bodies are unmistakable skeleton lines. A generated fake report with
 * invented specificity would be lying on the first touch — this shows the
 * SHAPE of what the owner will read every week, nothing more.
 */

import { FileText } from 'lucide-react';
import { deriveSectionTitle } from '@/lib/onboarding/draft-spec';

export function SampleReportPreview({
  routineName,
  companyName,
  questions,
}: {
  routineName?: string;
  companyName?: string;
  questions: Array<{ order: number; question: string }>;
}) {
  if (questions.length === 0) return null;

  return (
    <div className="rounded-xl border bg-muted/30 p-4">
      <div className="flex items-center justify-between">
        <p className="flex items-center gap-2 text-sm font-semibold">
          <FileText className="h-4 w-4 text-muted-foreground" />
          {companyName ? `${companyName}'s Monday report` : 'Your Monday report'}
        </p>
        <span className="rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          Sample preview
        </span>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">
        What lands in your inbox after each {routineName ? `"${routineName}"` : 'check-in'} run —
        trends, blockers, who can unblock whom.
      </p>
      <div className="mt-3 space-y-3">
        {questions.slice(0, 3).map((q) => (
          <div key={q.order}>
            <p className="text-xs font-semibold">{deriveSectionTitle(q.question)}</p>
            <div className="mt-1.5 space-y-1.5" aria-hidden>
              <div className="h-2 w-11/12 rounded bg-muted-foreground/15" />
              <div className="h-2 w-3/4 rounded bg-muted-foreground/15" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
